const CSS_PIXELS_PER_INCH = 96;
const MILLIMETRES_PER_INCH = 25.4;
const RECEIPT_WIDTH_MM = 80;
const MIN_RECEIPT_HEIGHT_MM = 50;
const CUTTER_FEED_MM = 4;

/**
 * Chrome requires both values in `@page size` to be concrete lengths. The
 * previously used `80mm auto` value is invalid, so it was ignored and the
 * printer driver's full page height appeared in preview (and on the roll).
 */
export const getReceiptPageStyle = (printRoot: HTMLElement | null) => {
  const receipt = printRoot?.querySelector<HTMLElement>(".receipt-root");
  const heightInPixels = receipt
    ? Math.max(receipt.scrollHeight, receipt.getBoundingClientRect().height)
    : 0;
  const measuredHeightMm =
    (heightInPixels * MILLIMETRES_PER_INCH) / CSS_PIXELS_PER_INCH;
  const pageHeightMm = Math.max(
    MIN_RECEIPT_HEIGHT_MM,
    Math.ceil(measuredHeightMm + CUTTER_FEED_MM)
  );

  return `
    @page {
      size: ${RECEIPT_WIDTH_MM}mm ${pageHeightMm}mm;
      margin: 0;
    }
    @media print {
      html,
      body {
        width: ${RECEIPT_WIDTH_MM}mm !important;
        height: ${pageHeightMm}mm !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }
    }
  `;
};
